import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { API_URL } from "../../../utils/Common";
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from "react-toasts";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import MyLoader from "../../sharecomponents/MyLoader";
import BoxAlert from "../../sharecomponents/BoxAlert";
import Modal from "../../sharecomponents/Modal";

const initForm = Object.freeze({
   cavidad: "",
   ciclocampo: "",
   codigo: "",
   //colorId: "",
   densidadm2: "",
   germinacion: "",
   id: "",
   nombre_cientifico: "",
   nombre_comun: "",
   porcentaje: "",
   propagacion: "",
   sexual: "",
   //variedad: "",
   tallos: "",
});

const initVariedad = Object.freeze({
   variedad: "",
});

const EditarFlor = (props) => {
   // -- parametros
   const idFlor = props.match.params.id;

   //const [colores, setColores] = useState([]);
   const [flor, setFlor] = useState(initForm);
   const [variedades, setVariedades] = useState([]);
   const [frmVariedad, setFrmVariedad] = useState(initVariedad);
   const [variedad, setVariedad] = useState({});

   // -- loader
   const [loader, updateLoader] = useState(false);

   const modalRef = useRef();

   useEffect(() => {
      getInfoFlor();
   }, []);

   const getInfoFlor = () => {
      updateLoader(true);
      axios.get(API_URL + "/getInfoEdicionFlor?idflor=" + idFlor).then((r) => {
         console.log(r.data);
         updateLoader(false);
         //setColores(r.data.colores);
         setFlor(r.data.flor);
         setVariedades(r.data.variedades);
      });
   };

   const handleChange = (e) => {
      setFlor({
         ...flor,
         [e.target.name]: e.target.value,
      });
   };

   const handleVariedad = (e) => {
      setFrmVariedad({
         ...frmVariedad,
         [e.target.name]: e.target.value,
      });
   };

   const onSubmit = (e) => {
      e.preventDefault();
      console.log(flor);
      updateLoader(true);
      axios
         .post(API_URL + "/updateFlor", { flor })
         .then(() => {
            updateLoader(false);
            props.history.goBack();
         })
         .catch((e) => console.log(e));
   };

   const submitVariedad = (e) => {
      e.preventDefault();
      updateLoader(true);
      axios.post(API_URL + "/setVariedad", { ...frmVariedad, idFlor }).then((r) => {
         updateLoader(false);
         setFrmVariedad(initVariedad);
         getInfoFlor();
         console.log(r.data);
      });
   };

   const remModal = (v) => {
      setVariedad(v);
      modalRef.current.showModal();
   };

   const actionModal = () => {
      console.log(variedad);
      axios
         .post(API_URL + "/removerVariedad", { ...variedad })
         .then((r) => {
            console.log(r.data);
            getInfoFlor();
            modalRef.current.hideModal();
         })
         .catch((e) => console.log(e));
   };

   return (
      <div className="w-full p-3">
         <div className="bg-white border rounded shadow">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <HeadRegresar titulo={`Editar Flor ${flor.nombre_comun}`} history={props.history} />
            </div>
            <div className="p-5 rounded-b">
               <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                     <h3 className="text-orange-900 font-bold">Datos Generales</h3>
                     <hr className="mb-5" />
                     <form className="w-full mb-3" onSubmit={onSubmit}>
                        <div className="flex flex-wrap -mx-3 mb-6">
                           <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                 Nombre Común:
                              </label>
                              <input
                                 className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="nombre_comun"
                                 onChange={handleChange}
                                 value={flor.nombre_comun}
                                 type="text"
                              />
                           </div>
                           <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                 Nombre Científico:
                              </label>
                              <input
                                 className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="nombre_cientifico"
                                 type="text"
                                 onChange={handleChange}
                                 value={flor.nombre_cientifico}
                              />
                           </div>
                        </div>
                        <hr className="mb-5" />

                        <div className="flex flex-wrap -mx-3 mb-6">
                           <div className="w-full md:w-1/4 px-3 mb-6 md:mb-0">
                              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                 % Recuperación:
                              </label>
                              <input
                                 className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="porcentaje"
                                 step="any"
                                 type="number"
                                 onChange={handleChange}
                                 value={flor.porcentaje}
                              />
                           </div>
                           <div className="w-full md:w-1/4 px-3 mb-6 md:mb-0">
                              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                 Densidad:
                              </label>
                              <input
                                 className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="densidadm2"
                                 step="any"
                                 type="number"
                                 onChange={handleChange}
                                 value={flor.densidadm2}
                              />
                           </div>
                           <div className="w-full md:w-1/4 px-3 mb-6 md:mb-0">
                              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                 Cavidad:
                              </label>
                              <input
                                 className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="cavidad"
                                 step="any"
                                 type="number"
                                 onChange={handleChange}
                                 value={flor.cavidad}
                              />
                           </div>
                           <div className="w-full md:w-1/4 px-3 mb-6 md:mb-0">
                              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                 Germinación:
                              </label>
                              <input
                                 className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="germinacion"
                                 step="any"
                                 type="number"
                                 onChange={handleChange}
                                 value={flor.germinacion}
                              />
                           </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                           <div className="w-full md:w-1/4 px-3 mb-6 md:mb-0">
                              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                 Cantidad Tallos:
                              </label>
                              <input
                                 className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="tallos"
                                 step="any"
                                 type="number"
                                 onChange={handleChange}
                                 value={flor.tallos}
                              />
                           </div>
                        </div>
                        <button
                           type="submit"
                           className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow"
                        >
                           <i className="far fa-edit" /> Actualizar información
                        </button>
                     </form>
                     <BoxAlert
                        titulo="NOTA"
                        mensaje="Se guradará la informacion de la flor solamante para las variedades utilizar el componente de la derecha"
                     />
                  </div>
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                     <h3 className="text-orange-900 font-bold">Variedades de la Flor</h3>
                     <hr className="mb-5" />
                     {/** Formulario ingreso del protocolo */}
                     <form className="mt-5" onSubmit={submitVariedad}>
                        <div className="text-sm flex flex-wrap -mx-3 mb-6">
                           <div className="w-1/2 px-3">
                              <label className="block tracking-wide text-gray-700 font-bold mb-2">Variedad:</label>
                              <input
                                 className="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 type="text"
                                 name="variedad"
                                 value={frmVariedad.variedad}
                                 onChange={handleVariedad}
                              />
                           </div>
                           <div className="w-1/2 px-3 mt-8">
                              <button
                                 className="text-sm bg-orange-700 hover:bg-orange-600 text-white py-2 px-4 rounded shadow focus:outline-none"
                                 type="submit"
                              >
                                 Agregar
                              </button>
                           </div>
                        </div>
                     </form>
                     {/** ./formulario */}
                     {/** tabla variedades */}
                     <table className="table-fixed mt-5">
                        <thead>
                           <tr className="border border-orange-800 text-white content-center bg-orange-800">
                              <th></th>
                              <th className="w-auto px-1 py-1">No</th>
                              <th className="w-auto px-1 py-1">Nombre</th>
                           </tr>
                        </thead>
                        <tbody>
                           {variedades.length > 0 &&
                              variedades.map((v, i) => {
                                 return (
                                    <tr key={i}>
                                       <td className="border px-4 py-2 m-0 w-5">
                                          <button className="px-1 py-1 focus:outline-none">
                                             <i className="far fa-trash-alt" onClick={() => remModal(v)} />
                                          </button>
                                       </td>
                                       <td className="border px-4 py-2">{i + 1}</td>
                                       <td className="border px-4 py-2">{v.nombre}</td>
                                    </tr>
                                 );
                              })}
                        </tbody>
                     </table>
                     {/** ./tabla variedades */}
                  </div>
               </div>
            </div>
         </div>
         {/** loading **/}
         {loader && <MyLoader />}
         {/** ./loading **/}
         <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
         {/** Modal */}
         <Modal
            titulo="Remover Variedad"
            mensaje={`¿Seguro de remover la Variedad ${variedad.nombre}?`}
            ref={modalRef}
            actionTitle="Remover"
            actionFn={actionModal}
         />
      </div>
   );
};

export default EditarFlor;
